import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Breadcrumbs, Sorting, SearchForm } from 'Blocks'
import config from 'Config'
import { routerPropTypes, productPropTypes } from 'Types'

const CategoryHeader = props => {
  // TODO: should put 'search, sort, and term' into constants
  const isSearch = props.params.subCategory === 'search'
  const heading = (() => {
    const termMatch = props.location.search.match(/term=([^&]*)/)
    const formatTerm = term => decodeURIComponent(term).replace(/\+/g, ' ')
    const term = termMatch ? formatTerm(termMatch[1]) : null

    if (isSearch && props.products.products.length === 0) {
      return `Nothing found for: ${term}`
    } else if (isSearch) {
      return `Search: ${term}`
    } else {
      return props.products.categories.current.name
    }
  })()

  const breadCrumbsProps = {
    className: 'breadcrumbs',
    gaEventContext: isSearch ? 'search' : 'category'
  }

  const isSearchClass = isSearch ? 'is-search' : 'is-category'
  const wrappedHeading = (
    <span className={`heading__content ${isSearchClass}`}>{heading}</span>
  )
  const headingContent = config.name === 'pm' ? wrappedHeading : heading

  return (
    <Fragment>
      {config.showSearchInTopBar ? (
        <div className="topbar">
          <Breadcrumbs {...breadCrumbsProps} />
          <SearchForm
            className="topbar-search"
            showSubmitButton={true}
            showSubmitButtonIcon={true}
          />
        </div>
      ) : (
        <Breadcrumbs {...breadCrumbsProps} />
      )}
      <h1 className={`heading ${isSearchClass}`}>{headingContent}</h1>
      <Sorting
        className="sorting"
        location={props.location}
        queryString={props.location.search}
      />
    </Fragment>
  )
}

CategoryHeader.propTypes = {
  ...routerPropTypes,
  products: PropTypes.shape({
    categories: PropTypes.shape({
      current: PropTypes.shape({
        name: PropTypes.any
      })
    }),
    products: PropTypes.arrayOf(PropTypes.shape({ ...productPropTypes }))
  })
}

export default CategoryHeader
